import { render, staticRenderFns } from "./QuiltyResourceFilePane.vue?vue&type=template&id=9fef2060&"
import script from "./QuiltyResourceFilePane.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceFilePane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fef2060')) {
      api.createRecord('9fef2060', component.options)
    } else {
      api.reload('9fef2060', component.options)
    }
    module.hot.accept("./QuiltyResourceFilePane.vue?vue&type=template&id=9fef2060&", function () {
      api.rerender('9fef2060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/quiltyResource/QuiltyResourceFilePane.vue"
export default component.exports